// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style_navigation__3D__C","inner":"style_inner__L2NOC","mobile":"style_mobile__2BNj7","active":"style_active__2Mq12"};